import React from 'react';
import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as reportGeneration from '../../../../../redux/reportGeneration';
import useReportContainer from '../context/useReportContainer';
import ProjectLevelPreview from '../projectLevel/Preview';
import ReleaseGroupPreview from '../releaseGroupLevel/Preview';
import type { ReportGenerationParams } from '../../shared/types';

import styles from './Preview.module.less';

type Props = {
  params: ReportGenerationParams;
};

const Preview: VoidFunctionComponent<Props> = (props: Props) => {
  const projectType = useSelector(reportGeneration.selectors.getProjectType);
  const {
    format,
    includeOptions,
    dependencyMetadataOptions,
    excludeOptions,
    fixPlanOptions,
    authorName,
    authorEmail,
    supplier,
  } = useReportContainer();

  const previewProps = {
    ...props,
    format,
    includeOptions,
    dependencyMetadataOptions,
    excludeOptions,
    fixPlanOptions,
    authorName,
    authorEmail,
    supplier,
  };

  return (
    <div className={styles.preview}>
      {projectType === 'project' ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <ProjectLevelPreview {...previewProps} />
      ) : (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <ReleaseGroupPreview {...previewProps} />
      )}
    </div>
  );
};

export default React.memo(Preview);
